<template>
    <v-dialog
            v-model="isDialogOpen"
            width="600"
            hide-overlay
            transition="dialog-bottom-transition"
    >
        <v-toolbar
                flat
                dark
                class="main--yellow"
        >
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn text @click.native="$emit('close')">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card>
            <v-container class="app-container">
                <v-card-title class="justify-center grey--text">{{ $t('messagesToSeller') }}</v-card-title>
                <v-divider class="my-2"></v-divider>
                <v-row>
                    <v-col cols="12" class="pt-2 pt-md-12">
                        <v-textarea
                                outlined
                                v-model="messageText"
                                :label="$t('messageText')"
                                color="orange lighten-2"
                        ></v-textarea>
                    </v-col>
                </v-row>
                <div class="d-flex justify-end">
                    <v-btn class="my-4" dark depressed color="main--yellow" @click="send">
                        {{ $t('send') }}
                    </v-btn>
                </div>
            </v-container>
        </v-card>
        <snack-general :snack-data="snackData"></snack-general>
    </v-dialog>
</template>

<script>

    import AppSnack from '../../../general/mixins/AppSnack';
    import DialogRemote from '../../mixins/DialogRemote';
    import MessagesService from '../../services/api/MessagesService';
    import SnackGeneral from '../snacks/SnackGeneral';

    export default {
        name: "CompanyDialog",
        props:['company'],
        mixins:[DialogRemote, AppSnack],
        components:{SnackGeneral},
        data(){
            return {
                messageText: null,
                snackData: {
                    isOpen: false,
                    color: '',
                    text: ''
                }
            }
        },
        methods: {
            send() {
                const params = {
                    companyId: this.company,
                    body: this.messageText,
                };

                MessagesService.messageToCompany(params)
                    .then(res => {
                        this.snackHandle(this.$t('messageSent'), 'main--black', true);
                        setTimeout(() => {
                            this.$emit('close');
                        }, 3000);
                        /*this.snackData = {
                            isOpen: true,
                            color: 'main--black',
                            text: this.$t('messageSent')
                        };*/
                    })
                    .catch(err => {
                        this.snackHandle(this.$t('changesSavedError'), 'error', true);
                        console.log(err);
                    });
            },
            snackHandle(text, color, isOpen) {
                this.snackData.color = color;
                this.snackData.text = text;
                this.snackData.isOpen = isOpen;
            },
        }
    }
</script>

<style scoped>

</style>